import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import AdminModal from '../AdminModal.js';
import AdminBulkPreview from '../AdminBulkPreview.js';

const BulkDeleteTeamsModal = ({ isOpen, onClose, onConfirm, teams, loading }) => (
  <AdminModal
    isOpen={isOpen && teams?.length > 0}
    onClose={onClose}
    title="Delete Teams"
    actions={(
      <>
        <button className="cancel-button" onClick={onClose} disabled={loading}>
          Cancel
        </button>
        <button className="admin-submit-button" onClick={onConfirm} disabled={loading}>
          {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Delete All Teams'}
        </button>
      </>
    )}
  >
    <p style={{ color: '#d32f2f', fontWeight: 'bold' }}>
      Are you sure you want to delete {teams?.length} team{teams?.length > 1 ? 's' : ''}? This action cannot be undone.
    </p>
    <AdminBulkPreview
      items={teams || []}
      getKey={(team) => team.teamId}
      getName={(team) => team.teamName}
      getMeta={(team) => `${team.userIds?.length || 0} member${team.userIds?.length !== 1 ? 's' : ''}`}
      noun="team"
    />
    <p style={{ marginTop: '15px', color: '#e74c3c', fontSize: '14px', fontWeight: '600' }}>
      All members will no longer be associated with these teams.
    </p>
  </AdminModal>
);

export default BulkDeleteTeamsModal;
